<template>
  <div class="law-enforcement-enquiry" id="law-enforcement-enquiry">
    <div class="title">
      {{ translateTitle("MASKEX执法调查") }}
    </div>
    <!-- <div class="content">
      {{
        translateTitle(
          "Please NOTE that you must be a Legal Enforcement Agent or a Government Official with the official capacity to gather evidence, to make this enquiry from MaskEX.",
        )
      }}
    </div> -->
    <div class="detail">
      <h2 class="detail-title">{{ translateTitle("MaskEX 执法请求指引") }}</h2>
      <div>
        {{
          translateTitle(
            "MaskEX 是一家虚拟资产交易平台及加密货币交易所。本页面仅用于与持续进行中的刑事调查相关的执法及政府正式请求。经授权的执法/政府人员可通过 Kodex 执法门户提交请求、跟踪案件进展，并在法律允许的情况下接收相关资料。本页面不适用于民事程序、私人调查或其他非政府主体请求。",
          )
        }}
      </div>

      <h2 class="detail-title">{{ translateTitle("如何提交请求") }}</h2>

      <div class="list">
        <p>
          {{
            translateTitle(
              "MaskEX 通过 Kodex Law Enforcement Portal 接收执法与法律程序请求。",
            )
          }}
        </p>
        <p>
          {{ translateTitle("登录：") }}
          <a href="https://app.kodexglobal.com/maskex/signin"
            >https://app.kodexglobal.com/maskex/signin</a
          >
        </p>
        <p>
          {{ translateTitle("注册：") }}
          <a href="https://app.kodexglobal.com/maskex/signup"
            >https://app.kodexglobal.com/maskex/signup</a
          >
        </p>
        <p>
          {{
            translateTitle(
              "如你此前未使用过 Kodex，请先完成注册。注册完成后，你即可通过该门户提交请求、跟踪案件状态，并接收通过门户共享的材料。",
            )
          }}
        </p>
      </div>

      <h2 class="detail-title">
        {{ translateTitle("提交请求时需提供的信息") }}
      </h2>

      <div>
        {{ translateTitle("为便于我们高效审查你的请求，请尽量提供：") }}
      </div>
      <ul class="email-items">
        <li>{{ translateTitle("所属机构名称及官方联系方式；") }}</li>
        <li>{{ translateTitle("适用的法律程序文件或其他官方支持文件；") }}</li>
        <li>
          {{
            translateTitle(
              "足够的识别信息，例如账户标识、钱包地址、交易哈希（TXID）或其他相关账户/交易信息；",
            )
          }}
        </li>
        <li>{{ translateTitle("对所请求信息或所需操作的清晰说明。") }}</li>
        <li>{{ translateTitle("机构网站（如适用）") }}</li>
      </ul>
      <p>
        {{
          translateTitle(
            "如请求缺少充分的支持文件或识别信息，可能会被延迟处理、退回补充说明或被拒绝。",
          )
        }}
      </p>
      <h2 class="detail-title">{{ translateTitle("可能涉及的信息类型") }}</h2>
      <div>
        <p>
          {{
            translateTitle(
              "在有效法律程序支持下，可能涉及的信息包括：账户注册信息与 KYC 信息、登录历史、IP 地址、设备相关信息、交易活动、订单历史、充提记录、钱包地址、链上交易信息，以及相关合规或客服记录，但均以适用法律、平台政策及实际数据可用性为准",
            )
          }}
        </p>
        <p>
          {{
            translateTitle(
              "如需进一步了解我们收集的数据类别，请查阅我们的隐私政策。",
            )
          }}
        </p>
      </div>

      <h2 class="detail-title">{{ translateTitle("紧急请求") }}</h2>
      <p>
        {{
          translateTitle(
            "如你提交的是紧急执法请求，请通过 Kodex 门户提交，并选择相应的紧急法律程序类型。紧急处理并不当然意味着披露。所有请求都将依据适用法律及 MaskEX 政策进行审查，且我们可能要求补充支持材料。",
          )
        }}
      </p>
      <h2 class="detail-title">{{ translateTitle("保全请求") }}</h2>
      <p>
        {{
          translateTitle(
            "如你希望我们对相关记录进行保全，请通过 Kodex 门户提交，并提供足够的识别信息及适用的支持文件。保全适用于相关账户、交易、钱包、链上记录及其他响应性资料，但保全本身不当然构成信息披露。",
          )
        }}
      </p>
      <h2 class="detail-title">{{ translateTitle("用户通知") }}</h2>
      <p>
        {{
          translateTitle(
            "除非支持文件另有明确说明，或适用法律禁止通知，MaskEX 可能会就相关信息披露事宜通知相关用户。",
          )
        }}
      </p>
      <h2 class="detail-title">{{ translateTitle("国际请求 / MLAT") }}</h2>
      <p>
        {{
          translateTitle(
            "对于来自任何具备管辖权司法辖区并附有官方文件的请求，可通过 Kodex 门户提交，以供我们就持续进行中的刑事调查进行审查。必要时，我们可能要求提交经翻译、认证或其他形式上充分的材料。",
          )
        }}
      </p>

      <h2 class="detail-title">{{ translateTitle("技术支持") }}</h2>
      <div>
        <p>
          {{
            translateTitle("如你在注册或登录 Kodex 时遇到技术问题，请联系：")
          }}
        </p>
        <a href="mailto:help@kodexglobal.com">help@kodexglobal.com</a>
      </div>

      <h2 class="detail-title">{{ translateTitle("其他问题") }}</h2>
      <p>
        {{
          translateTitle(
            "如对执法请求提交流程有一般性问题，请通过 Kodex 门户联系。若你已有正在处理中的请求，请优先在现有案件线程内补充信息或提出后续问题。",
          )
        }}
      </p>
    </div>

    <div class="bten">
      <!-- <el-checkbox v-model="checked" :fill="'#15beb4'">{{
        translateTitle("I have read and agree to this disclaimer")
      }}</el-checkbox> -->
    </div>
    <div class="btn">
      <!-- <el-button
        :class="!checked ? 'no' : 'on'"
        @click="pathJump"
        :disabled="!checked"
        type="info"
        round
        >{{ translateTitle("Begin Enquiry") }}</el-button
      > -->
    </div>
    <div></div>
  </div>
</template>
<script>
import { translateTitle } from "@/assets/js/i18n";
import commonMixin from "@/components/common/commonMixin.vue";
export default {
  data() {
    return {
      checked: false,
    };
  },
  mixins: [commonMixin],
  methods: {
    pathJump() {
      window.open("https://forms.gle/kBrehoX1Y2wiuRpC8");
    },
  },
};
</script>

<style lang="scss">
.email-items {
  list-style: disc;
  margin-left: 18px;
  > li {
    list-style: disc;
  }
}
.el-scrollbar__view {
  background: #fff;
}
#law-enforcement-enquiry {
  .el-checkbox__input.is-checked .el-checkbox__inner,
  .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #15beb4 !important;
    border-color: #15beb4 !important;
  }
  .el-button--info.on {
    background-color: #15beb4;
    border-color: #15beb4;
  }
  .el-button--info.no {
    background-color: #d6d6d6;
    border-color: #d6d6d6;
  }
}
.law-enforcement-enquiry {
  width: 800px;
  margin: 0 auto;
  // background-color: #fff;
  .title {
    font-size: 38px;
    margin-top: 100px;
    font-weight: bold;
    color: #15192a;
  }
  .content {
    margin-top: 30px;
    font-size: 18px;
    color: #15192a;
  }
  .detail {
    a {
      color: #1f73b7;
    }
    margin-top: 35px;
    padding: 23px 34px;
    font-size: 16px;
    // font-family: DIN;
    line-height: 30px;
    color: #15192a;
    background-color: #f8f8f8;
  }
  .bten {
    text-align: center;
    margin-top: 50px;
    font-size: 14px;
    color: #333;
  }
  .btn {
    margin-top: 35px;
    text-align: center;
    margin-bottom: 35px;
    // padding
    span {
      padding: 5px 15px;
    }
    //     width: 160px;
    //     height: 48px;
    //     display: inline-block;
    //     line-height: 48px;
    //     color: #fff;
    //     cursor: pointer;
    //     border-radius: 50px;
    //     background-color: #15beb4;
    //     margin-top: 35px;
    // }
  }
}

.detail-title {
  font-size: 24px;
  font-weight: 500;
  margin-bottom: 12px;
  margin-top: 30px;

  &:first-child {
    margin-top: 0;
  }
}
</style>
